import { Patient, SelectedModel } from './../../../../models/patient/patient.model';
import { DialogService } from './../../../../shared/services/dialog.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseService } from '../../../../shared/services/base.service';
import { AppMessages } from '../../../../shared/constants/messages';
import { AppConstants } from '../../../../shared/constants/constants';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { SharedModule } from '../../../../shared/shared.module';
import { Utility } from '../../../../common/utility';
import { ValidationService } from '../../../../shared/services/validation.service';
import { ListMemberService } from '../list-member.service';

@Component({
  selector: 'add-member-popup',
  templateUrl: 'add-member-popup.component.html',
  providers: [ListMemberService]
})
export class AddMemberPopupComponent implements OnInit {
  public patientForm: FormGroup;
  public patientModel = new Patient();
  public isSuccess: boolean;

  // just for test
  public members = [];
  public listTitle = [];
  public listCountryOfBirth = [];
  public listCountry = [];
  public listOccupation = [];
  public listSex = [];
  public occupationStudent = [];
  constructor(
    public utility: Utility,
    private formBuilder: FormBuilder,
    private router: Router,
    public dialogRef: MatDialogRef<AddMemberPopupComponent>,
    public dialogService: DialogService,
    public listMemberManageService: ListMemberService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { this.createForm(); }

  ngOnInit() {
    this.initData();
    this.getCountryData();
    this.listSex = this.listMemberManageService.getSexData();
  }
  getCountryData() {
    this.listMemberManageService.getCountryList().subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.listCountry = data;
          this.listCountryOfBirth = data;

        }
      }
    );
  }
  initData() {
    this.listMemberManageService.getInit().subscribe(
      result => {
        if (result) {
          const data = result.json();
          this.listOccupation = data['occupations'];
          this.listTitle = data['titles'];
          const studentId = this.listOccupation.find(o => o.name === 'Student');
          this.occupationStudent = studentId['id'];
        }
      }
    );
  }

  createForm() {
    const dateOfBirth = new Date('1999-01-01');
    const newModel = new SelectedModel();
    this.patientForm = this.formBuilder.group({
      title: [null, [Validators.required]],
      firstName: ['', [Validators.required]],
      surName: ['', [Validators.required]],
      sex: [null, [Validators.required]],
      dateOfBirth: [dateOfBirth, [Validators.required, ValidationService.isValidDateOfBirth]],
      countryOfBirthId: [null, [Validators.required]],
      address1: ['', [Validators.required]],
      address2: ['', [Validators.required]],
      mobilePhone: ['', [Validators.required]],
      countryId: [null, [Validators.required]],
      email: ['', [Validators.required, ValidationService.isValidEmail]],
      occupationId: [null, [Validators.required]],
      country: [''],
      countryOfBirth: [''],
      occupation: [''],
      address: [''],
      name: ['']
    });
  }

  onSave() {
    this.markAsTouch();
    this.patientForm.updateValueAndValidity();
    if (this.patientForm.valid && this.patientForm.dirty && ((this.members.length + this.data.list.length) < 9)) {
      this.resetFormValue();
      this.members.push(this.patientForm.value);
      this.dialogRef.close(this.members);
    } else if (((this.members.length + this.data.list.length) >= 9)) {
      this.dialogService.openErrorDialog({ message: AppMessages.requestForAppointment.errorAddMember });
    }
  }

  onSaveAnother() {
    this.markAsTouch();
    if (this.patientForm.valid && this.patientForm.dirty && ((this.members.length + this.data.list.length) < 9)) {
      this.resetFormValue();
      this.members.push(this.patientForm.value);
      this.createForm();
    } else if (((this.members.length + this.data.list.length) >= 9)) {
      this.dialogService.openErrorDialog({ message: AppMessages.requestForAppointment.errorAddMember });
    }
  }

  resetFormValue() {
    this.listCountry.forEach(element => {
      if (element.id === this.patientForm.controls['countryId'].value) {
        this.patientForm.controls['country'].setValue(element.name);
      }
    });
    this.listCountryOfBirth.forEach(element => {
      if (element.id === this.patientForm.controls['countryOfBirthId'].value) {
        this.patientForm.controls['countryOfBirth'].setValue(element.name);
      }
    });
    this.listOccupation.forEach(element => {
      if (element.id === this.patientForm.controls['occupationId'].value) {
        this.patientForm.controls['occupation'].setValue(element.name);
      }
    });
    this.patientForm.controls['address']
      .setValue(this.patientForm.controls['address1'].value + ', ' + this.patientForm.controls['address2'].value);

    this.patientForm.controls['name']
      .setValue(this.patientForm.controls['firstName'].value + ' ' + this.patientForm.controls['surName'].value);
  }

  onCloseDialog() {
    this.dialogRef.close(this.members);
  }

  checkDuplicateEmail(list, dataForm) {
    if (list.length > 0) {
      if (list.findIndex(item => item.email.toLowerCase() === dataForm.email.toLowerCase()) !== -1) {
        return true;
      }
    }
    return false;
  }

  markAsTouch() {
    for (const key in this.patientForm.controls) {
      if (this.patientForm.controls.hasOwnProperty(key)) {
        this.patientForm.controls[key].markAsTouched();
        this.patientForm.controls[key].updateValueAndValidity();
      }
    }
  }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/request-appointment/list-member/small-group/add-member-popup.component.ts